import React from "react";
import "./About.css";
import ReduxIcon from "../assets/redux.png";
import HTML from "../assets/html.png";
import JEST from "../assets/jest.png";
import Figma from "../assets/figma.png";
import ReactIcon from "../assets/react.png";
import NPMlogo from "../assets/npm.png";
import GitLogo from "../assets/git.png";
import GitHublogo from "../assets/github.png";
import WebPack from "../assets/webpack.png";
import PostGres from "../assets/postgres.png";
import CSS from "../assets/css.png";
import BootStrap from "../assets/bootstrap.png";
import JavaScript from "../assets/javascript.png";
import Sass from "../assets/sass.png";
import PostMan from "../assets/postman.png";
import MaterialUi from "../assets/materialui.png";
import StyledComponent from "../assets/styledcomponent.png";
import NodeJs from "../assets/nodejs.png";
import Express from "../assets/express.png";
import MongoDb from "../assets/mongodb.png";
import NextJs from "../assets/next.webp";
import Mongoose from "../assets/mongoose.png";
import Tailwind from "../assets/tailwind.png";
import Knex from "../assets/knex.png";
import Netlify from "../assets/netlify.png";
import GithubActions from "../assets/githubaction.png";
import Eslint from "../assets/esling.png";
import Yarn from "../assets/yarn.png";
import Docker from "../assets/docker.png";
import MongoDbAtlass from "../assets/mongodbatlass.png";
import Azura from "../assets/azura.png";
import FireBase from "../assets/firebase.png";
import CSharp from "../assets/cSharp.png"
import Blazor from "../assets/blazor.png"
import DotNet from "../assets/dotNet.png"
import Kurbenetes from "../assets/kurbenetes.png"
import Python from "../assets/python.png"
import OpenAi from "../assets/openAi.png"
import Lambda from "../assets/lambda.png"
import Milvus from "../assets/milvus.png"
import PyPDF from "../assets/pypdf.png"

const About = () => (
  <section className="about" id="about">
    <div className="about-me">
      <h2 className="title about-title">About me</h2>
      <p className="paragraph about-para">
     My journey in the world of programming began in 2020, when I started
      working with my friends on different projects. Since then, I have had
      the opportunity to work on a wide range of projects, improving my skills.
      and expanding my knowledge along the way. I have worked with various
      clients and companies, both independently and as part of a team.
      </p>
    </div>
    <div className="about-skills">
      <h2 className="skill-title">Front-End</h2>
      <div className="skills">
      <div className="skill">
          <img src={JavaScript} alt="JavaScript" />
          <p>JavaScript</p>
        </div>
        <div className="skill">
          <img src={ReactIcon} alt="React" />
          <p>React</p>
        </div>
        <div className="skill">
          <img src={Blazor} alt="Blazor" />
          <p>Blazor</p>
        </div>
        <div className="skill">
          <img src={NextJs} alt="Next JS" />
          <p>Next JS</p>
        </div>
        <div className="skill">
          <img src={ReduxIcon} alt="Redux" />
          <p>Redux</p>
        </div>
        <div className="skill">
          <img src={HTML} alt="HTML5" />
          <p>HTML5</p>
        </div>
        <div className="skill">
          <img src={CSS} alt="CSS3" />
          <p>CSS3</p>
        </div>
        <div className="skill">
          <img src={Sass} alt="SASS" />
          <p>SASS</p>
        </div>
        <div className="skill">
          <img src={BootStrap} alt="Bootstrap" />
          <p>Bootstrap</p>
        </div>
        <div className="skill">
          <img src={MaterialUi} alt="MaterialUi" />
          <p>MaterialUi</p>
        </div>

        <div className="skill">
          <img src={Tailwind} alt="Tailwind" />
          <p>Tailwind</p>
        </div>
        <div className="skill">
          <img src={StyledComponent} alt="StyledComponent" />
          <p>
            Styled<br></br>Component
          </p>
        </div>
      </div>

      <h2 className="skill-title">Back-End</h2>
      <div className="skills">
        <div className="skill">
          <img src={NodeJs} alt="NodeJs" />
          <p>NodeJs</p>
        </div>
        <div className="skill">
          <img src={CSharp} alt="C#" />
          <p>C#</p>
        </div>
        <div className="skill">
          <img src={Python} alt="Python" />
          <p>Python</p>
        </div>
        <div className="skill">
          <img src={Express} alt="Express" />
          <p>Express</p>
        </div>
        <div className="skill">
          <img src={DotNet} alt=".Net" />
          <p>.Net</p>
        </div>
        <div className="skill">
          <img src={Knex} alt="Knex.Js" />
          <p>Knex.Js</p>
        </div>
        <div className="skill">
          <img src={PostGres} alt="PostgreSQL" />
          <p>PostgreSQL</p>
        </div>
        <div className="skill">
          <img src={MongoDb} alt="MongoDb" />
          <p>MongoDb</p>
        </div>
        <div className="skill">
          <img src={Mongoose} alt="Mongoose" />
          <p>Mongoose</p>
        </div>
      </div>

      <h2 className="skill-title">Tools</h2>
      <div className="skills">
        <div className="skill">
          <img src={GitLogo} alt="Git" />
          <p>Git</p>
        </div>
        <div className="skill">
          <img src={GitHublogo} alt="GitHub" />
          <p>GitHub</p>
        </div>
        <div className="skill">
          <img src={JEST} alt="Jest" />
          <p>JEST</p>
        </div>
        <div className="skill">
          <img src={Docker} alt="Docker" />
          <p>Docker</p>
        </div>
        <div className="skill">
          <img src={Eslint} alt="Eslint" />
          <p>Eslint</p>
        </div>
        <div className="skill">
          <img src={Yarn} alt="Yarn" />
          <p>Yarn</p>
        </div>
        <div className="skill">
          <img src={WebPack} alt="Webpack" />
          <p>Webpack</p>
        </div>
        <div className="skill">
          <img src={PostMan} alt="Postman" />
          <p>Postman</p>
        </div>
        <div className="skill">
          <img src={NPMlogo} alt="npm" />
          <p>npm</p>
        </div>
      </div>
      <h2 className="skill-title">Deploy & CI/CD</h2>
      <div className="skills">
        <div className="skill">
          <img src={Netlify} alt="Netlify" />
          <p>Netlify</p>
        </div>
        <div className="skill">
          <img src={Kurbenetes} alt="Kurbenetes" />
          <p>Kurbenetes</p>
        </div>
        <div className="skill">
          <img src={GithubActions} alt="" />
          <p>Github Actions</p>
        </div>
      </div>
      <h2 className="skill-title">Cloud</h2>
      <div className="skills">
        <div className="skill">
          <img src={MongoDbAtlass} alt="" />
          <p>Mongo Db Atlass</p>
        </div>
        <div className="skill">
          <img src={Azura} alt="" />
          <p>Azura</p>
        </div>
        <div className="skill">
          <img src={FireBase} alt="" />
          <p>Fire Base</p>
        </div>
      </div>
      <h2 className="skill-title">AI / Machine Learning</h2>
      <div className="skills">
        <div className="skill">
          <img src={OpenAi} alt="" />
          <p>OpenAI</p>
        </div>
        <div className="skill">
          <img src={Lambda} alt="" />
          <p>Lambda LLM</p>
        </div>
        <div className="skill">
          <img src={Milvus} alt="" />
          <p>Milvus</p>
        </div>
        <div className="skill">
          <img src={PyPDF} alt="" />
          <p>PyPDF</p>
        </div>
      </div>
      <h2 className="skill-title">Soft Skills</h2>
      <div className="skills">
        <p className="soft-skill">
          <span>&#10003;</span> Communication
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Mentoring
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Collaboration
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Leadership
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Problem Solving
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Time Management
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Decision Making
        </p>
        <p className="soft-skill">
          <span>&#10003;</span> Critical Thinking
        </p>
      </div>
    </div>
  </section>
);

export default About;
